const channel = new BroadcastChannel('countdown_channel');

export const sendMessage = (data: any) => {
  channel.postMessage(data);
};

export const receiveMessage = (callback: any) => {
 const handleMessage = (event: any) => {
   callback(event.data);
 };

 channel.addEventListener('message', handleMessage);

 return () => {
   channel.removeEventListener('message', handleMessage);
 };
};

export const closeChannel = () => {
  channel.close();
};